import { AfterViewInit, Component, OnInit } from '@angular/core';
import get from 'lodash-es/get';
import transform from 'lodash-es/transform';

// Components
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
// Classes
import { BaseFilter } from '@finder/shared/components/filters/classes/base-filter.class';
import { Facet } from '@finder/shared/services/filter-emitter-service/facet.class';
import { TopFilterButton } from '@finder/shared/components/filters/classes/top-filter-button.class';
// Services
import { FilterEmitterService } from '@finder/shared/services/filter-emitter-service/filter-emitter.service';
import { FinderAnalyticsService } from '@finder/shared/services/finder-analytics/finder-analytics.service';
import { LocalStorageService } from '@finder/shared/services/local-storage/local-storage.service';
import { RaCheckboxComponent } from '@finder/shared/components/ra-wrappers/ra-checkbox/ra-checkbox.component';
import { ButtonComponent } from '@finder/shared/components/button/button.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'finder-mobile-filters',
    templateUrl: './mobile-filters.component.html',
    styleUrls: ['./mobile-filters.component.scss'],
    standalone: true,
    imports: [
        RaCheckboxComponent,
        ButtonComponent,
        CommonModule,
    ],

})
export class MobileFiltersComponent extends BaseFilter implements OnInit, AfterViewInit {

    data: any;
    filterGroups: any;
    labels: any;
    parentComponent: ModalComponent;

    constructor(
        protected filterEmitterService: FilterEmitterService,
        protected finderAnalyticsService: FinderAnalyticsService,
        protected localStorageService: LocalStorageService

    ) {
        super(filterEmitterService, finderAnalyticsService, localStorageService);
    }

    ngOnInit() {
        this.filters = get(this.data, 'filters');
        this.labels = get(this.data, 'labels', {});
        super.ngOnInit();
        this.setFilterGroups();
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    handleWatchFacet(facet: Facet) {
        this.topFilters.forEach((filter: TopFilterButton) => this.setFilterState(filter, facet));
        this.applyFacet(facet);
    }

    onCheck(event, filter) {
        if (filter.selected === event.detail.value) {
            return;
        }
        this.toggleTopFilter(filter);
    }

    setFilterGroups() {
        const filterGroups = get(this.filters, 'filterGroups', {});

        // Transform the array of grouped urlFriendlyIds into an array of grouped TopFilters.
        this.filterGroups = transform(filterGroups, (res, filterGroup: Array<string>, key: string) => {
            const group = [];
            filterGroup.forEach(urlFriendlyId => {
                const topFilter = this.topFilters.find(filter => filter.id === urlFriendlyId);
                /* istanbul ignore else */
                if (topFilter) {
                    group.push(topFilter);
                }
            });
            res.push({
                type: key,
                filters: group
            });

            return res;
        }, []);
    }

    dismiss() {
        this.parentComponent.dismiss();
    }
}
